import './App.css';

import VoyageModel from "./VoyageModel";

import local_testdata from "./testdata.json";
import local_testdata_urls from "./testdata_urls.json";

// Load raw data
const API_KEY = process.env.REACT_APP_SHEETS_API_KEY;
const SPREADSHEET_ID = "1NhRMjoNgEMyl96WFuXUZ_BK3DS-tCl12ZA4jhbxR9hQ";
const SHEET_NAME = "Old for TB"

let raw_data, raw_url_data;
if (API_KEY) {
  raw_data = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${SHEET_NAME}?key=${API_KEY}`)
                             .then(response => response.json())
                             .then(data => data.values);
  raw_url_data = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}?ranges='${SHEET_NAME}'!A:A&key=${API_KEY}&fields=sheets(data(rowData(values(hyperlink))))`)
                             .then(response => response.json())
                             .then(data => data.sheets[0].data[0].rowData)
                             .then(rowData => rowData.map(x => Object.keys(x).length ? x.values[0].hyperlink : ""));
} else {
  console.log("No REACT_APP_SHEETS_API_KEY set - using local testdata.json instead of Google Sheets");
  raw_data = local_testdata;
  raw_url_data = local_testdata_urls.reverse();
}

// Find end of table
let last_nonempty_row;
for (let i = 0; i < raw_data.length; i++) {
  if (raw_data[i].length !== 0) {
    last_nonempty_row = i;
  } else if (raw_data[i].length === 0 || raw_data[i][0] === "") {
    break;
  }
}

// Trim empty rows and summary row
const data_w_headers = raw_data.slice(0, last_nonempty_row+1);
let url_data = [];
for (let j = 0; j < last_nonempty_row+1; j++) {
  url_data.push((j in raw_url_data) ? raw_url_data[j] : "");
}
// FYI
console.log(data_w_headers)
console.log(url_data)

// Extract name headers, and put trips in ascending order
const data_names    = data_w_headers[0].slice(2);
const data_wo_names = data_w_headers.slice(1).reverse();
const urls          = url_data.reverse();

// Extract trip headers
const trip_dates        = data_wo_names.map((row) => row[0]);
const trip_key_memories = data_wo_names.map((row) => row[1]);
const data_wo_headers   = data_wo_names.map((row) => row.slice(2));

// Convert to binary
const data_binary = data_wo_headers.map(row => {
  const row_binary = row.map(entry => {switch(entry) {
    case "": return 0;
    default: return parseInt(entry);
  }});
  while (row_binary.length < data_names.length) {
    row_binary.push(0);
  }
  return row_binary;
});

function App() {
  return (
    <div className="App">
      <VoyageModel data_names={data_names}
                   trip_dates={trip_dates}
                   trip_key_memories={trip_key_memories}
                   data_binary={data_binary}
                   hammock_diary_urls={urls}/>
    </div>
  );
}

export default App;
